module.exports = "/static/assets/f24ef0e4d71d4580436281c036ec1b5a.png";